"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extensions = void 0;
/**
 * Implementation of the external Extensions namespace.
 */
class Extensions {
    constructor(extensionImpl) {
        this.extensionImpl = extensionImpl;
        this.extensionImpl = extensionImpl;
    }
    get dashboardContent() {
        return this.extensionImpl.dashboardContent;
    }
    get worksheetContent() {
        return this.extensionImpl.worksheetContent;
    }
    get environment() {
        return this.extensionImpl.environment;
    }
    get settings() {
        return this.extensionImpl.settings;
    }
    get ui() {
        return this.extensionImpl.ui;
    }
    get workbook() {
        return this.extensionImpl.workbook;
    }
    get dashboardObjectId() {
        return this.extensionImpl.extensionZoneId;
    }
    initializeAsync(contextMenuCallbacks) {
        return this.extensionImpl.initializeAsync(false, contextMenuCallbacks).then();
    }
    initializeDialogAsync() {
        return this.extensionImpl.initializeAsync(true);
    }
    createVizImageAsync(inputSpec) {
        return this.extensionImpl.createVizImageAsync(inputSpec);
    }
    setClickThroughAsync(clickThroughEnabled) {
        return this.extensionImpl.setClickThroughAsync(clickThroughEnabled);
    }
    reportExtensionRenderComplete(mediaBlob) {
        return this.extensionImpl.reportExtensionRenderComplete(mediaBlob);
    }
}
exports.Extensions = Extensions;
//# sourceMappingURL=Extensions.js.map